import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import styles from './index.module.css'
import SEO from '../components/SEO'
import anime from 'animejs'

const anienter = function() {
  var windowWidth = 1000
  typeof window !== 'undefined' && (windowWidth = window.innerWidth)
  if (windowWidth < 700) {
    anime({
      targets: '.anienter',
      translateX: '-11vw',
      translateY: '-40vh',
      duration: 2000,
      width: '100px'
    })
  }
  if (windowWidth > 700) {
    anime({
      targets: '.anienter',
      translateX: '50vw',
      translateY: '-40vh',
      duration: 2000,
      width: '100px'
    })
  }
}

const IndexPage = ({ data, history, location }) => (
  <div className={styles.wrapper}>
    <SEO slug={'Home'} />
    <Link to="/editorial/" onClick={anienter}>
      <Img className="anienter" sizes={data.logo.childImageSharp.sizes} />
    </Link>
  </div>
)
export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js